import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import {createStore} from './store';
import Root from './Root';

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

// Let webpack know where to load files from in production envs.
// This is primarily for code-splitting scenarios and for images.
if (!module.hot) {
    __webpack_public_path__ = `${window.cdnUrl}/`; // eslint-disable-line no-undef, camelcase
}

// Initial state as set by the server-side render
const initialState = window.__INITIAL_STATE__;

const store = createStore(initialState);

ReactDOM.hydrate(<Root store={store}/>, document.getElementById('root'));
